import axios from "axios";
import {baseUrl } from "../variables/variables";

  const LoginService  = {
     login : (request)=>{
      return axios
      .post(`${baseUrl}/login`, request) 
     }

  }


  

export { LoginService };
